import { DialogContent } from '@mui/material'
import styled from 'styled-components'

export const ContentContainer = styled(DialogContent)`
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
`

export const FooterContainer = styled(DialogContent)`
  padding: 0px !important;
`
